module.exports = __webpack_public_path__ + "static/media/feature_4.2259b8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_4.png
// module id = 1253
// module chunks = 0